// toFixed strips floating point noise (e.g. 2.2 - 1.7 = 0.5000000000000002)
// so it isn't rounded up to the next half
export const roundUpToNearestHalf = (price: number): number =>
  Math.ceil(Number((price * 2).toFixed(6))) / 2;
